import { Sun, Moon } from "lucide-react";
import { useAdminTheme } from "@/contexts/AdminThemeContext";

export default function AdminThemeToggle() {
  const { theme, toggle } = useAdminTheme();
  const isDark = theme === "dark";
  return (
    <button
      onClick={toggle}
      data-testid="admin-theme-toggle"
      title={isDark ? "Switch to light mode" : "Switch to dark mode"}
      aria-label="Toggle theme"
      className="text-white/40 hover:text-[#C5A059] transition-colors"
    >
      {isDark ? <Sun size={18} /> : <Moon size={18} />}
    </button>
  );
}
